import { Vue, Component } from 'vue-property-decorator'
import { VAvatar, VBtn, VIcon, VImg } from 'vuetify/lib'

@Component({})
export class ObfuscateView extends Vue {
	isObfuscate: boolean = false

	render() {
		return (
			<VBtn icon onClick={() => this.toggleObfuscate()} aria-label={this.isObfuscate ? 'Esconder dados' : 'Exibir dados'}>
				<VIcon size="24" color="primary" vShow={!this.isObfuscate}>
					mdi-eye-outline
				</VIcon>

				<VImg vShow={this.isObfuscate} src="/vectors/propostas/icon-closed-eye.svg" contain width="20" height="20" />
			</VBtn>
		)
	}
	toggleObfuscate() {
		this.isObfuscate = !this.isObfuscate
		this.$root.$emit('emmit-obfuscate')
	}
}

export default ObfuscateView
